import React from "react";

import * as productsAPI from "../../../api/products";
import { useMountEffect } from "../../../hooks/useMountEffect";
import { IProduct } from "../../../models/catalogue";
import { ICompareTile } from "../../../models/product-compare";
import { setSelectedRootProduct } from "../../configurator/reducers";
import { rootProductSelector } from "../../configurator/selectors";
import { useAppDispatch, useAppSelector } from "../../reducers";
import { ProductCompareSelectionTile as ProductCompareSelectionTileComponent } from "../elements/ProductCompareSelectionTile";

async function loadProducts(tile: ICompareTile): Promise<IProduct[]> {
    const products = await Promise.all(
        tile.product_compare_tile.product_ids.map((pid) => {
            const productURL = productsAPI.getProductURL(pid);
            return productsAPI.getProduct(productURL);
        }),
    );
    return products;
}

export const ProductCompareSelectionTile = (props: {
    tile: ICompareTile;
}): React.ReactNode => {
    const [products, setProducts] = React.useState<IProduct[]>([]);
    const dispatch = useAppDispatch();
    const pageRootProduct = useAppSelector((rootState) => {
        const rootProduct = rootProductSelector(rootState.configurator);
        return rootProduct ? rootProduct.id : null;
    });

    useMountEffect(() => {
        let isMounted = true;

        loadProducts(props.tile).then((loadedProducts) => {
            if (isMounted) {
                setProducts(loadedProducts);
            }
        });

        return () => {
            isMounted = false;
        };
    });

    const onProductSelect = () => {
        if (products.length > 0) {
            dispatch(setSelectedRootProduct(products[0]));
        }
    };

    const isSelected =
        props.tile.product_compare_tile.product_id === pageRootProduct;

    return (
        <div>
            <ProductCompareSelectionTileComponent
                products={products}
                isSelected={isSelected}
                onProductSelect={onProductSelect}
            />
        </div>
    );
};
